"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  computed: {
    vSize: function vSize() {
      var $parent = this.$parent,
        size = this.size;
      return size || $parent && ($parent.size || $parent.vSize);
    }
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/mixins/size.js
// module id = 21
// module chunks = 75